import { Field, FieldProps, FormikErrors, FormikTouched, FormikValues } from 'formik';
import _get from 'lodash/get';
import React from 'react';
import intl from 'react-intl-universal';
import classnames from 'classnames';
import { ListMeetingsQuery } from 'typings/types';
import searchAllUsersQuery from 'queries/users/searchAllUsersQuery.gql';
import listAllUsersAndRoomsQuery from 'queries/joined/listAllUsersAndRoomSystemsQuery.gql';
import * as formStyles from 'components/Modals/ModalForms.scss';
import { MEETING_FORM_FIELD } from '../FormFields';
import ContactSearchSelection from 'components/ContactSearchSelection/ContactSearchSelection';

enum RoleType {
  OWNER = 'owner',
  MODERATOR = 'moderator',
  LECTURER = 'lecturer'
}

export interface OwnProps {
  editingThisLecturer?: ListMeetingsQuery.Moderator | null | undefined;
  editingThisModerator?: ListMeetingsQuery.Moderator | null | undefined;
  editingThisOwner?: ListMeetingsQuery.Moderator | null | undefined;
  errors: FormikErrors<FormikValues>;
  handleChange: Function;
  isEditingExistingMeeting?: boolean;
  touched: FormikTouched<FormikValues>;
  values: FormikValues;
}

interface StateProps {
  currentUser: object;
}

export type Props = StateProps & OwnProps;

class RolesTab extends React.Component<Props> {

  render(): React.ReactNode {

    const {
      currentUser,
      editingThisModerator,
      editingThisOwner,
      editingThisLecturer,
      isEditingExistingMeeting,
      touched,
      errors,
      handleChange

    } = this.props;

    const ownerTouched = _get(touched, RoleType.OWNER, false);
    const ownerErrors = _get(errors, RoleType.OWNER, null);
    const moderatorTouched = _get(touched, RoleType.MODERATOR, false);
    const moderatorErrors = _get(errors, RoleType.MODERATOR, null);

    return (
      <div>
        <div id="owner" className={classnames(formStyles.formGroup, formStyles.hasValidation)}>
          <label className={formStyles.labelLarge}>{intl.get('meetingOwner')}</label>
          <div className={formStyles.inputContainer}>
            <div className={formStyles.selectContainer}>
              <Field
                name={MEETING_FORM_FIELD.OWNER}
                render={({}: FieldProps<string>) => {
                  return (
                    <ContactSearchSelection
                      placeholder={intl.get('meetingOwner')}
                      onChange={(selection: object) => handleChange({ target: { name: 'owner', value: selection }})}
                      currentSelection={
                        isEditingExistingMeeting ?
                          { id: _get(editingThisOwner, 'UUID', null), title: _get(editingThisOwner, 'displayName', '') } :
                          { id: _get(currentUser, 'id', null), title: _get(currentUser, 'name', '') }
                      }
                      query={searchAllUsersQuery}
                    />
                  );
                }}
              />
            </div>
            <ul className={formStyles.inputMessages}>
              {touched && errors && ownerTouched && ownerErrors ? (
                <li className={formStyles.error}>{ownerErrors}</li>
              ) : null}
            </ul>
          </div>
        </div>

        <div id="moderator" className={classnames(formStyles.formGroup, formStyles.hasValidation)}>
          <label className={formStyles.labelLarge}>{intl.get('moderator')}</label>
          <div className={formStyles.inputContainer}>
            <div className={formStyles.selectContainer}>
              <Field
                name={MEETING_FORM_FIELD.MODERATOR}
                render={({}: FieldProps<string>) => (
                  <ContactSearchSelection
                    placeholder={intl.get('meetingModerator')}
                    onChange={(selection: object) => handleChange({ target: { name: 'moderator', value: selection }})}
                    currentSelection={
                      isEditingExistingMeeting ?
                        { id: _get(editingThisModerator, 'UUID', null) , title: _get(editingThisModerator, 'displayName', '') } :
                        { id: _get(currentUser, 'id', null), title: _get(currentUser, 'name', '') }
                    }
                    query={listAllUsersAndRoomsQuery}
                  />
                )}
              />
            </div>
            <ul className={formStyles.inputMessages}>
              {touched && errors && moderatorTouched && moderatorErrors ? (
                <li className={formStyles.error}>{moderatorErrors}</li>
              ) : null}
            </ul>
          </div>
        </div>

        <div id="lecturer" className={formStyles.formGroup}>
          <label className={formStyles.labelLarge}>{intl.get('lecturer_optional')}</label>
          <div className={formStyles.inputContainer}>
            <div className={formStyles.selectContainer}>
              <Field
                name={MEETING_FORM_FIELD.LECTURER}
                render={({}: FieldProps<string>) => (
                  <ContactSearchSelection
                    placeholder={intl.get('meetingLecturer')}
                    onChange={(selection: object) => handleChange({ target: { name: 'lecturer', value: selection }})}
                    currentSelection={
                      isEditingExistingMeeting ?
                        { id: _get(editingThisLecturer, 'UUID', null), title: _get(editingThisLecturer, 'displayName', '') } :
                        { id: null, title: '' }
                    }
                    isOptional={true}
                    query={listAllUsersAndRoomsQuery}
                  />
                )}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default RolesTab;
